/**
 * Orders API Queries
 *
 * Query keys and read operations.
 */

// API client
import { apiClient } from '../client';

// Types
import type { Order } from './types';

export const ordersQueryKeys = {
  all: ['orders'] as const,
  lists: () => [...ordersQueryKeys.all, 'list'] as const,
  list: (params?: Record<string, unknown>) => [...ordersQueryKeys.lists(), params] as const,
  details: () => [...ordersQueryKeys.all, 'detail'] as const,
  detail: (id: number) => [...ordersQueryKeys.details(), id] as const,
};

export async function getOrder(id: number): Promise<Order> {
  const response = await apiClient.get<Order>(`/orders/${id}/details`);
  return response.data;
}

export async function getOrders(params?: Record<string, unknown>): Promise<{ data: Order[]; totalCount: number; currentPage: number; totalPages: number }> {
  const response = await apiClient.get<{ data: Order[]; totalCount: number; currentPage: number; totalPages: number }>('/orders', { params });
  return response.data;
}
